module.exports = __webpack_public_path__ + "static/media/door-is-wrong.395b7819.mp3";